import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Cancel, CheckCircle, Schedule } from '@mui/icons-material';
import * as statuses from 'services/store/states';
import { getRefundRequest, sendRefundRequest } from 'services/network/api/invoicing';
import { addToast } from 'services/store/features/toasts/actions';
import styles from './RefundRequest.module.css';
import { logError } from 'utils/logs';
export default function RefundRequest({ idStripe, idProject }) {
    const [status, setStatus] = useState(statuses.IDLE);
    const [request, setRequest] = useState({ fetched: false, data: null });
    const [showConfirm, setShowConfirm] = useState(false);
    useEffect(() => {
        const fetchRefundRequest = async () => {
            if (!request.fetched) {
                try {
                    const { data } = await getRefundRequest();
                    setRequest({
                        fetched: true,
                        data: data.find((curr) => curr.investment_id === idStripe) || null,
                    });
                }
                catch (err) {
                    logError(err);
                    setRequest({ fetched: true, data: null });
                }
            }
        };
        fetchRefundRequest();
    }, []);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const requestRefund = async () => {
        if (!showConfirm) {
            setShowConfirm(true);
        }
        else {
            setStatus(statuses.LOADING);
            try {
                await sendRefundRequest({
                    investment_id: idStripe,
                    action: 'creation',
                    id_ayomi: idProject,
                });
                setStatus(statuses.SUCCESS);
                setRequest({
                    fetched: true,
                    data: {
                        action: 'creation',
                        isValidated: false,
                        isAyomi: false,
                        status: true,
                    },
                });
                dispatch(addToast({
                    type: 'success',
                    title: t('dashboard.wallet.request_refund_success_title'),
                    description: t('dashboard.wallet.request_refund_success_description'),
                }));
            }
            catch (err) {
                logError(err);
                setStatus(statuses.FAIL);
                dispatch(addToast({
                    type: 'error',
                    title: t('dashboard.wallet.request_refund_error_title'),
                    description: t('dashboard.wallet.request_refund_error_description'),
                }));
            }
        }
    };
    if (request.data
        && (request.data.status === true)) {
        return (_jsxs("p", { className: styles.info, children: [_jsx(Schedule, { className: styles.icon }), _jsx("span", { children: t('dashboard.wallet.request_refund_pending') })] }));
    }
    if (request.data
        && (request.data.status === false)
        && (request.data.isValidated)) {
        return (_jsxs("p", { className: styles.validated, children: [_jsx(CheckCircle, { className: styles.icon }), _jsx("span", { children: t('dashboard.wallet.request_refund_accepted') })] }));
    }
    if (request.data
        && (request.data.status === false)
        && (!request.data.isValidated)) {
        return (_jsxs("p", { className: styles.rejected, children: [_jsx(Cancel, { className: styles.icon }), _jsx("span", { children: t('dashboard.wallet.request_refund_rejected') })] }));
    }
    return (_jsxs(_Fragment, { children: [showConfirm
                && (_jsx("div", { className: `${styles.background} fadeIn`, children: _jsxs("section", { className: `${styles.modal} bounceIn`, children: [_jsx("p", { className: styles.title, children: t('dashboard.wallet.request_refund_confirm') }), _jsx("p", { className: styles.description, children: t('dashboard.wallet.request_refund_confirm_description') }), _jsxs("div", { className: styles['button-group'], children: [_jsx("button", { type: "button", onClick: () => setShowConfirm(false), disabled: status === statuses.LOADING || status === statuses.SUCCESS, className: styles.button, children: t('dashboard.wallet.request_refund_cancel') }), _jsx("button", { type: "button", onClick: requestRefund, disabled: status === statuses.LOADING || status === statuses.SUCCESS, className: `${styles.button} ${styles.danger}`, children: status === statuses.LOADING
                                            ? (_jsxs("span", { className: styles.loader, children: [_jsx("span", { className: "loader white" }), t('dashboard.wallet.request_refund_loading')] })) : t('dashboard.wallet.request_refund_launch') })] })] }) })), _jsx("button", { type: "button", onClick: requestRefund, disabled: !request.fetched || status === statuses.LOADING || status === statuses.SUCCESS, className: styles.button, children: t('dashboard.wallet.request_refund') })] }));
}
